import login from './login.json';
import signup from './signup.json';
import settings from './settings.json';
import integrations from './integrations.json';
import integrationApps from './integrationApps.json';
import inboxMgmt from './inboxMgmt.json';
import generalSettings from './generalSettings.json';
import agentMgmt from './agentMgmt.json';
import zid from './zid.json';
import salla from './salla.json';
import auditLogs from './auditLogs.json';

export default {
  ...login,
  ...signup,
  ...settings,
  ...integrations,
  ...integrationApps,
  ...inboxMgmt,
  ...generalSettings,
  ...agentMgmt,
  ...zid,
  ...salla,
  ...auditLogs,
};
